<template>
  <div
    class="editor-promo-block__wrapper editor-wrapper text-container"
    :class="{ editable: editable }"
  >
    <div class="editor-promo-block">
      <div class="editor-promo-block__title-wrapper">
        <EditorContentEditable
          class="editor-promo-block__title"
          :contenteditable="editable"
          placeholder="Заголовок ссылки"
          :text="title"
          @blur="handleTitleChange"
        />
        <a :href="href" target="_blank"
          ><SvgIcon name="editor/right-arrow"
        /></a>
      </div>
      <EditorContentEditable
        class="editor-promo-block__description"
        :contenteditable="editable"
        placeholder="Краткое описание ссылки"
        :text="description"
        @blur="handleDescriptionChange"
      />
    </div>
    <template v-if="editable">
      <EditorPromoBlockEdit
        class="promo-block-edit"
        :href="href"
        @change="handleHrefChange"
        @delete="emit('delete')"
        @error="emit('error', $event)"
      />
    </template>
  </div>
</template>

<script setup>
defineProps({
  editable: { type: Boolean, default: false },
  title: { type: [String, Number], default: '' },
  href: { type: String, default: null },
  description: { type: [String, Number], default: '' },
});

const emit = defineEmits([
  'update:title',
  'update:description',
  'update:href',
  'delete',
  'error',
]);

const handleTitleChange = (e) => {
  emit('update:title', e.target.innerText);
};

const handleDescriptionChange = (e) => {
  emit('update:description', e.target.innerText);
};

const handleHrefChange = (href) => {
  emit('update:href', href);
};
</script>
